import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

constructor(
  private store: Store
) { }

dispatch(action: any) {
  setTimeout(() => {
    this.store.dispatch(action)
  }, 0);
}

}
